import React, { useMemo } from "react";
import { Lock } from "lucide-react";
import { formatPlayCountdown } from "../../hooks/usePendingPlayCountdown";

const BondPlayReservedTicket = ({
  variant = "dice",
  actionVerb = "Play",
  pickLabel,
  stakeLabel,
  maxWinLabel,
  ttlMs,
  secondsLeft,
  expired = false,
}) => {
  const isUrgent =
    !expired && secondsLeft != null && secondsLeft > 0 && secondsLeft <= 15;
  const progress =
    secondsLeft != null && ttlMs ? Math.max(0, Math.min(100, (secondsLeft / (ttlMs / 1000)) * 100)) : 0;
  const countdownLabel = useMemo(() => formatPlayCountdown(secondsLeft), [secondsLeft]);

  return (
    <section
      className={`bcoin-reserved-ticket bcoin-reserved-ticket--${variant}${isUrgent ? " urgent" : ""}${expired ? " expired" : ""}`}
      aria-label="Reserved ticket"
    >
      <div className="bcoin-reserved-ticket-top">
        <span className="bcoin-reserved-ticket-badge">
          <Lock size={11} aria-hidden />
          Reserved
        </span>
        <p className="bcoin-reserved-ticket-meta">
          <strong>{pickLabel}</strong>
          <span className="bcoin-reserved-ticket-meta-muted"> · {stakeLabel} · </span>
          <span className="bcoin-reserved-ticket-meta-win">{maxWinLabel}</span>
        </p>
      </div>

      {secondsLeft != null ? (
        <div className="bcoin-reserved-ticket-timer" role="status" aria-live="polite">
          {expired ? (
            <span className="bcoin-reserved-ticket-expired">Expired — stake refunded</span>
          ) : (
            <>
              <span className="bcoin-reserved-ticket-timer-prefix">{actionVerb} in</span>
              <span className="bcoin-reserved-ticket-timer-value">{countdownLabel}</span>
              <div className="bcoin-reserved-ticket-progress" aria-hidden>
                <span style={{ width: `${progress}%` }} />
              </div>
            </>
          )}
        </div>
      ) : null}
    </section>
  );
};

export default BondPlayReservedTicket;
